module.exports = __webpack_public_path__ + "static/media/blind-destiny-mp.5af1fbcd.png";